import { BsFillEnvelopeExclamationFill, BsGoogle, BsInstagram, BsLinkedin, BsTwitter, BsYoutube } from "react-icons/bs";
import { PiExamFill, PiFacebookLogo, PiGoodreadsLogo } from "react-icons/pi";
import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <div className="bg-blue-100 mt-8   md:px-12 text-[rgb(10,26,66)] pt-8 px-4">


            <div className="  md:flex md:justify-between">
                <div className="">
                    <img src="/logo.png"
                        className="w-24 "
                        alt="" />
                    <h3 className="text-sm w-[500px] max-[568px]:w-[100%] md:w-[300px] leading-6">
                        DRIC is a Christian private boarding secondary
                        school situated east of Niger. We are the Light
                        of the World, "Pace Setters" and model instruments
                        in the hand of God both in secular and spiritual
                        endeavors
                    </h3>
                </div>

                <div className="border-b-2 pb-4 text-sm pt-8 leading-8 md:border-0 border-gray-500 text-[#0a1a42]">
                    <h2>+2347038638417</h2>
                    <h2>info@dricng</h2>
                </div>


                <div className="block">
                    <div className="space-y-4 pt-8 flex flex-col text-[#0a1a42] pb-4 md:border-0 border-b-2 border-gray-500">
                        <Link to={'/'}>About Us</Link>
                        <Link to={'/admission'}>Admissions</Link>
                        <Link to={'/contact'}> Contact Us</Link>
                        <Link to={'/curriculum'}>Curriculum</Link>
                        <Link to={'/gallery'}>Gallery</Link>
                    </div>

                </div>

            </div>

            <div className="space-y-4 pt-8 text-[#0a1a42] ">
                <span className="flex justify-center space-x-24 pb-4">
                    <h2 className="hover:text-[#f7951e]">Terms & Conditions</h2>
                    <h2 className="hover:text-[#f7951e]">Privacy Policy</h2>
                </span>

                <span className="flex space-x-8 justify-center pb-4">
                    <PiFacebookLogo className="text-2xl hover:text-[#f7951e]" />
                    <BsTwitter className="text-2xl hover:text-[#f7951e]" />
                    <BsInstagram className="text-2xl hover:text-[#f7951e]" />
                    <BsLinkedin className="text-2xl hover:text-[#f7951e]" />
                    <BsFillEnvelopeExclamationFill className="text-2xl hover:text-[#f7951e]" />
                    <BsYoutube className="text-2xl hover:text-[#f7951e]" />
                    <BsGoogle className="text-2xl hover:text-[#f7951e]" />
                </span>

                <div className="text-center text-sm text-[#0a1a42] pb-8">
                    <h2 className="">
                        © 2023. Divine School Int'l . All rights reserved.</h2>
                </div>
            </div>
        </div>
    );
}

export default Footer;